export const getTimeStampFromSeconds = (seconds) => {
    const timeStamp = new Date(seconds * 1000).toISOString().substr(11, 8);
    const splitTime = timeStamp.split(':');

    return {
        hours: splitTime[0],
        minutes: splitTime[1],
        seconds: splitTime[2]
    };
};

export const removeLeadingZerosFromTime = (time) => {
    const splitTime = time.split('0');
    //the time passed in will always contain a two digit number. 
    //Splitting against a 0 will return an array with a length of 2 if a zero is the first digit
    //and an array with a length of 1 if the number has double digits
    if (splitTime.length === 2 && !splitTime[0]) {
        return splitTime[1]; 
    }

    return time;
};

const formatTimeString = (timeUnit, time) => {
    const formattedTime = removeLeadingZerosFromTime(time);
    return `${formattedTime} ${formattedTime == '1' ? timeUnit : `${timeUnit}s`}`;
}

export const getLocationString = ({hours, minutes, seconds}) => {
    let timeString = '';
    const containsHours = parseInt(hours) > 0;
    const containsMinutes = parseInt(minutes) > 0;

    if (containsHours) {
        const hoursString = formatTimeString('hour', hours)
        timeString += `${hoursString} `;
    }

    if (containsMinutes) {
        const minutesString = formatTimeString('minute', minutes);
        timeString += `${minutesString} `;
    }

    const secondsString = formatTimeString('second', seconds);   
    timeString += secondsString;

    return timeString;
};

export const getTimeForAriaLabel = (time) => {
    const timeStamp = getTimeStampFromSeconds(time);
    const timeForAriaLabel = getLocationString(timeStamp);

    return timeForAriaLabel;
}

export const getQuizAriaLabel = (index, time) => {
    return `Quiz question ${index} at ${getTimeForAriaLabel(time)} in video`;
};


